









































































interface Fee {
    type?: string;
    isSelect: boolean;
    isOther?: boolean;
    dateFrom: Date | string;
    dateTo: Date | string;
    discount: string;
    shouldFee: number;
    totalFee?: number;
    remark?: string;
    tmp: number;
}
interface total {
    fee: number;
    balance: number;
    realGet: string;
    useBalance: boolean;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"])
})
export default class ChargeTypeInner extends Vue {
    @Prop({ type: Object })
    book?: Charge.Charge;

    @Prop({ type: Object })
    model?: Fee;

    // pickerOptions初值为空对象,因为还未获取到两个限制的时间
    disabledFee: DatePickerOptions = {
        disabledDate: time => {
            return (
                time < this.$utils.dateAdd(new Date(), "y", -2) ||
                time > this.$utils.dateAdd(new Date(), "year", 3)
            );
        }
    };

    @Watch("book", { deep: true })
    bookChange(val: Charge.Charge) {
        this.getFrom(val);
    }

    mounted() {
        if (this.book) {
            this.getFrom(this.book);
        }
    }

    // 获取当前期间 是否有初始期间， 无则为空，有则为接口的初始化时间
    getFrom(val: Charge.Charge) {
        if (this.book && this.model) {
            // 记账费 且有月收费初始开始期间
            if (val.monthlyPeriod != null && this.model.type === "记账费") {
                let dateAdd = this.$utils.dateAdd(
                    new Date(
                        val.monthlyPeriod.substring(0, 4) +
                            "-" +
                            val.monthlyPeriod.substring(4)
                    ),
                    "month",
                    1
                );
                this.model.dateFrom = dateAdd;
                this.changeFrom(this.model.dateFrom);
            } else if (
                val.annualPeriod != null &&
                this.model.type === "账本费"
            ) {
                let dateFrom = this.$utils.dateAdd(
                    new Date(
                        val.annualPeriod.substring(0, 4) +
                            "-" +
                            val.annualPeriod.substring(4)
                    ),
                    "month",
                    1
                );
                this.model.dateFrom = dateFrom;
                this.changeFrom(this.model.dateFrom);
            }
        }
    }

    // 当开始期间修改，结束期间随之改变，年：+11月，季：+2月，月：相等
    changeFrom(val: Date | string) {
        if (this.model && this.book) {
            if (val === null || val === "") {
                this.model.dateFrom === "";
                this.model.dateTo === "";
            } else {
                switch (this.book.chargeMethod) {
                    case "月付": {
                        this.model.dateTo = this.model.dateFrom;
                        break;
                    }
                    case "年付": {
                        this.model.dateTo = this.$utils.dateAdd(
                            new Date(this.model.dateFrom),
                            "month",
                            11
                        );
                        break;
                    }
                    case "季付": {
                        this.model.dateTo = this.$utils.dateAdd(
                            new Date(this.model.dateFrom),
                            "month",
                            2
                        );
                        break;
                    }
                    case "半年付": {
                        this.model.dateTo = this.$utils.dateAdd(
                            new Date(this.model.dateFrom),
                            "month",
                            5
                        );
                        break;
                    }
                }
            }

            this.$emit("update:model", this.model);
        }
    }
}
